import React, { useEffect } from "react";

// LIBRARIES
import { Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

// MISC
import { appRoutes } from "config/AppRoutesConfig";

//REDUX
import { selectLanguage } from "slices/LanguageSlice/languageSlice";

// COMPONENTS
import LayoutWrapper from "components/LayoutWrapper/LayoutWrapper";
import HomePage from "view/Home/HomePage";
import AboutPage from "view/About/AboutPage";
import LegislationSection from "view/LegislationSection/LegislationSection";
import LegislationDetails from "view/LegislationDetails/LegislationDetails";
import NewsAndMedia from "view/NewsAndMedia/NewsAndMedia";
import NewsAndPartners from "view/NewsAndMedia/NewsAndPartners/NewsAndPartners";
import NewsAndPartnersDetails from "view/NewsAndMedia/NewsAndPartners/NewsAndPartnersDetails/NewsAndPartnersDetails";
import OfficialAnnouncements from "view/NewsAndMedia/OfficialAnnouncements/OfficialAnnouncements";
import OfficialAnnouncementsDetails from "view/NewsAndMedia/OfficialAnnouncements/OfficialAnnouncementsDetails/OfficialAnnouncementsDetails";
import EmergencyCommunicationDetails from "view/Home/EmergencyCommunication/EmergencyCommunication";
import CNSUDecisions from "view/CNSUDecisions/CNSUDecisions";
import LegislationWindow from "view/LegislationWindow/LegislationWindow";
import Newsletter from "view/Newsletter/Newsletter";
import CivicDialogue from "view/CivicDialogue/CivicDialogue";
import Agenda from "view/Agenda/Agenda";
import LegislationOrders from "view/LegislationOrders/LegislationOrders";
import InterministerialConsultations from "view/Consultations/InterministerialConsultations";
import Projects from "view/Projects/Projects";
import ProjectDetails from "view/ProjectDetails/ProjectDetails";
import DetailsEvent from "view/DetailsEvent/DetailsEvent";
import Events from "view/Events/Events";
import AboutLegislation from "view/AboutLegislation/AboutLegislation";
import LegislationEvents from "view/LegislationEvents/LegislationEvents";
import InstitutionsContact from "view/InstitutionsContact/InstitutionsContact";
import Contact from "view/Contact/Contact";
import DSUNumbers from "view/DSUNumbers/DSUNumbers";
import Cookies from "view/CookieModule/CookieModule";
import Partners from "view/Partners/Partners";
import ActivityReports from "view/ActivityReports/ActivityReports";
import MapComponent from "view/Map/Map";
import AboutRegulations from "view/AboutRegulations/AboutRegulations";
import CampaignDetails from "view/CampaignDetails/CampaignDetails";
import QualityManagement from "view/QualityManagement/QualityManagement";
import CampaignArchive from "view/CampaignArchive/CampaignArchive";
import CookieModule from "view/CookieModule/CookieModule";
import Search from "view/Search/Search";

const AppRoutes = () => {
  // LIBRARY CONSTANTS

  const { i18n } = useTranslation();
  const currentLanguage = useSelector(selectLanguage);

  // LIFE CYCLE

  useEffect(() => {
    i18n.changeLanguage(currentLanguage);
    //eslint-disable-next-line
  }, []);

  return (
    <Routes>
      <Route path="/" element={<LayoutWrapper hasHeader={true} />}>
        <Route index element={<HomePage />} />
        <Route
          path={appRoutes.emergencyCommunication + ":id"}
          element={<EmergencyCommunicationDetails />}
        />
        <Route path={appRoutes.about} element={<AboutPage />} />
        <Route
          path={appRoutes.aboutLegislation}
          element={<AboutLegislation />}
        />

        <Route path={appRoutes.dsuNumbers} element={<DSUNumbers />} />
        <Route path={appRoutes.news} element={<NewsAndMedia />} />
        <Route path={appRoutes.newsletter} element={<Newsletter />} />
        <Route path={appRoutes.search} element={<Search />} />
        <Route path={appRoutes.officials} element={<OfficialAnnouncements />} />
        <Route path={appRoutes.dialog} element={<CivicDialogue />} />
        <Route
          path={appRoutes.officialsDetails + ":id"}
          element={<OfficialAnnouncementsDetails />}
        />
        <Route path={appRoutes.newsAndPartners} element={<NewsAndPartners />} />
        <Route path={appRoutes.campaignArchive} element={<CampaignArchive />} />
        <Route
          path={appRoutes.newsAndPartnersDetails + ":id"}
          element={<NewsAndPartnersDetails />}
        />
        <Route
          path={appRoutes.projectDetails + ":id"}
          element={<ProjectDetails />}
        />
        <Route
          path={appRoutes.eventDetails + ":id"}
          element={<DetailsEvent />}
        />
        <Route
          path={appRoutes.campaignsDetails + ":id"}
          element={<CampaignDetails />}
        />
        <Route path={appRoutes.events} element={<Events />} />
        <Route path={appRoutes.dialog} element={<></>} />
        <Route path={appRoutes.map} element={<MapComponent />} />
        <Route path={appRoutes.map + "/:rgxId"} element={<MapComponent />} />
        <Route path={appRoutes.contact} element={<Contact />} />
        <Route path={appRoutes.legislation} element={<LegislationSection />} />
        <Route path={appRoutes.agenda} element={<Agenda />} />
        <Route
          path={appRoutes.legislationDetails}
          element={<LegislationDetails />}
        />
        <Route
          path={appRoutes.legislationOrders}
          element={<LegislationOrders />}
        />
        <Route
          path={appRoutes.legislationConsults}
          element={<InterministerialConsultations />}
        />
        <Route
          path={appRoutes.legislationDecisions}
          element={<CNSUDecisions />}
        />
        <Route
          path={appRoutes.legislationWindow}
          element={<LegislationWindow />}
        />
        <Route path={appRoutes.projects} element={<Projects />} />
        <Route
          path={appRoutes.legislationEvents}
          element={<LegislationEvents />}
        />
        <Route
          path={appRoutes.legislationRegulations}
          element={<AboutRegulations />}
        />
        <Route
          path={appRoutes.legislationOrganisation}
          element={<AboutLegislation />}
        />
        <Route
          path={appRoutes.institutionsContact}
          element={<InstitutionsContact />}
        />
        <Route path={appRoutes.cookies} element={<Cookies />} />
        <Route path={appRoutes.activityReports} element={<ActivityReports />} />
        <Route path={appRoutes.partners} element={<Partners />} />
        <Route path={appRoutes.activityReports} element={<ActivityReports />} />
        <Route
          path={appRoutes.qualityManagement}
          element={<QualityManagement />}
        />
        <Route path={appRoutes.partners} element={<Partners />} />
        <Route path={appRoutes.gdpr} element={<CookieModule />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
